// extracted by css-extract-rspack-plugin
export default {"root":"CwH46i"};